import React from 'react'

const BillingDashboard = () => {
  return <div>Billing Dashboard</div>
}

export default BillingDashboard
